import { render } from "./TheSubCategories.vue?vue&type=template&id=52b30806&scoped=true"
import script from "./TheSubCategories.vue?vue&type=script&lang=js"
export * from "./TheSubCategories.vue?vue&type=script&lang=js"

import "./TheSubCategories.vue?vue&type=style&index=0&id=52b30806&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b30806"]])

export default __exports__